import { useState } from 'react';
import { isNil, reject } from 'ramda';

const useDisplayedPricing = (
  pricings,
  numberOfDisplayedPricings = 3,
  keepFirstColumnFixed = true
) => {
  const [displayedPricingsIndex, setDisplayedPricingsIndex] = useState(0);

  const updatePricingsTabsPagination = (direction) => {
    if (direction === 'left' && displayedPricingsIndex > 0) {
      setDisplayedPricingsIndex(displayedPricingsIndex - 1);
    }

    if (
      direction === 'right' &&
      displayedPricingsIndex < pricings.length - numberOfDisplayedPricings
    ) {
      setDisplayedPricingsIndex(displayedPricingsIndex + 1);
    }
  };

  const isPricingsTabsButtonDisabled = (direction) => {
    if (direction === 'left') {
      return displayedPricingsIndex === 0;
    }

    if (direction === 'right') {
      return displayedPricingsIndex === pricings.length - numberOfDisplayedPricings;
    }
  };

  const displayedPricings = reject(isNil, keepFirstColumnFixed
    ? [
      pricings[0],
      ...pricings.slice(
        displayedPricingsIndex + 1,
        displayedPricingsIndex + numberOfDisplayedPricings
      )
    ]
    : pricings.slice(displayedPricingsIndex, displayedPricingsIndex + numberOfDisplayedPricings)
  );

  return {
    displayedPricings,
    displayedPricingsIndex,
    updatePricingsTabsPagination,
    isPricingsTabsButtonDisabled
  };
};

export default useDisplayedPricing;
